export enum Modes {
  Add = 'add',
  Customization = 'customization'
}

export enum ScalingTypes {
  Cpu = 'CPU',
  Disc = 'DISC',
  Ram = 'RAM',
  Container = 'CONTAINER'
}

// Tabs that don't map to a backend resource (no entry in ScalingDialogData buckets).
export enum DialogMetaTabs {
  Overrides = 'overrides'
}

export type DialogTab = ScalingTypes | DialogMetaTabs;

export interface ScalingDialogData {
  // `undefined` is a valid state — embedded mode collapses all panes by clearing the active tab.
  type: DialogTab | undefined;
  [ScalingTypes.Disc]: {
    min: number;
    // placeholder for 'min' value
    defaultMin: number;
    max: number;
    // placeholder for 'max' value
    defaultMax: number;
  },
  [ScalingTypes.Container]: {
    min: number;
    // placeholder for 'min' value
    defaultMin: number;
    max: number;
    // placeholder for 'max' value
    defaultMax: number;
  } | undefined,
  [ScalingTypes.Cpu]: {
    min: number;
    // placeholder for 'min' value
    defaultMin: number;
    max: number;
    // placeholder for 'max' value
    defaultMax: number;
    // whole number (like 24)
    minFree: number;
    // decimal (helper) value (like 0.24)
    minFreeNum: number;
    // placeholder for 'minFree' value
    defaultMinFree: number;
    minFreePct: number;
    // placeholder for 'minFreePct' value
    defaultMinFreePct: number;
    startCount?: number;
    // placeholder for 'startCount' value
    defaultStartCount: number;
  },
  [ScalingTypes.Ram]: {
    min: number;
    // placeholder for 'min' value
    defaultMin: number;
    max: number;
    // placeholder for 'max' value
    defaultMax: number;
    minFree: number;
    // placeholder for 'minFree' value
    defaultMinFree: number;
    minFreePct: number;
    // placeholder for 'minFreePct' value
    defaultMinFreePct: number;
  }
}
